import { Fragment } from 'react'
import clsx from 'clsx'
import Link from 'next/link'

import { ICONS } from '@constants/icons.constants'

import { RaIcon, RaTypography } from '../index.core'

import styles from '../RaNavbarDropdown/ra-navbar-dropdown.module.scss'

import { KEYDOWN_EVENTS } from '@/constants/gravity-forms.constants'
import { Loop } from '@/utilities/helpers/loop.helpers'
import { stripFrontendUrl } from '@/utilities/helpers/strip-fe-url.helpers'
import { unescapeHTML } from '@/utilities/helpers/unescape-html.helpers'

const RaNavbarDropdownSectionChildLink = ({
  menu,
  index,
  disablePrefetch,
  count,
  returnFocusToParent,
  parent,
}) => {
  const CHILD_LINK = `child-link-${parent}`
  const handleKeyDown = e => {
    e.preventDefault()
    const nextItem = document.getElementById(`${CHILD_LINK}${index + 1}`)
    const prevItem = document.getElementById(`${CHILD_LINK}${index - 1}`)
    const firstItem = document.getElementById(`${CHILD_LINK}${0}`)
    const lastItem = document.getElementById(`${CHILD_LINK}${count - 1}`)
    if (
      e.keyCode === KEYDOWN_EVENTS.ARROW_DOWN ||
      e.keyCode === KEYDOWN_EVENTS.TAB
    ) {
      if (nextItem) {
        nextItem.focus()
      } else if (index + 1 === count) {
        firstItem.focus()
      }
    }
    if (e.keyCode === KEYDOWN_EVENTS.ARROW_UP) {
      if (prevItem) {
        prevItem.focus()
      } else if (index === 0) {
        lastItem.focus()
      }
    }
    if (e.keyCode === KEYDOWN_EVENTS.ARROW_RIGHT) {
      const childSection = document.getElementById(
        `dropdown-child-section-${parent}`
      )
      if (childSection) {
        const href = childSection.querySelectorAll('a')?.[0]
        if (href) {
          href.focus()
        }
      }
    }

    if (e.keyCode === KEYDOWN_EVENTS.ARROW_LEFT) {
      returnFocusToParent()
    }
  }

  if (typeof menu !== 'object') return null
  if (!menu.link?.title) return null

  return (
    <li className={styles['nav-dropdown__content__list__item']}>
      <Link
        href={stripFrontendUrl(menu.link?.url)}
        title={menu.link?.title}
        target={menu.link?.target}
        prefetch={!disablePrefetch && menu.link.target !== '_blank'}
        onKeyDown={handleKeyDown}
        id={`${CHILD_LINK}${index}`}>
        <RaTypography
          component="span"
          size="s">
          {unescapeHTML(menu.link?.title)}
        </RaTypography>
        <RaIcon icon={ICONS.LINK_ARROW} />
      </Link>
    </li>
  )
}

export const RaNavbarDropdownSectionChild = ({
  menu,
  disablePrefetch,
  returnFocusToParent,
}) => {
  if (!menu?.subitems?.length) return null
  const parent = menu.link.title

  let SectionTitleTag = Fragment
  const linkProps: any = {}
  if (menu?.link?.url && menu?.link?.url !== '#') {
    SectionTitleTag = Link
    linkProps.href = stripFrontendUrl(menu.link.url)
    linkProps.title = unescapeHTML(menu.link.title)
    linkProps.targe = menu.link.target
  }

  const isShortMenu = menu?.subitems?.length < 5

  return (
    <div
      id={`dropdown-child-section-${parent}`}
      className={styles['nav-dropdown__content__child-section']}>
      {menu?.link?.title && (
        <SectionTitleTag {...linkProps}>
          <RaTypography
            component="span"
            fontFamily="heading"
            color="primary">
            {unescapeHTML(menu.link?.title)}
          </RaTypography>
        </SectionTitleTag>
      )}
      <ul
        className={clsx(
          styles['nav-dropdown__content__list'],
          isShortMenu && styles['nav-dropdown__content__list--short']
        )}>
        {Loop(menu.subitems, (item, i: number) => (
          <RaNavbarDropdownSectionChildLink
            menu={item}
            key={i}
            index={i}
            disablePrefetch={disablePrefetch}
            count={menu.subitems.length}
            returnFocusToParent={returnFocusToParent}
            parent={parent}
          />
        ))}
      </ul>
    </div>
  )
}
